import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useDirection } from '~/hooks';
import { QuestionIcon } from '~/img';
import styled from 'styled-components';
import direction from '~/utils/direction';

const PayrollHeader: FC<{ onClick: () => void }> = (props) => {
  const { t } = useTranslation('payrolls');
  const [dir] = useDirection();
  return (
    <Container onClick={props.onClick} dir={dir}>
      {t('Payroll')}
      <QuestionIcon />
    </Container>
  );
};

const Container = styled.span`
  display: inline-flex;
  justify-content: center;
  cursor: pointer;
  align-items: center;

  .anticon {
    font-size: 16px;
    ${direction.margin.left(8)};
  }
`;

export default PayrollHeader;
